<template>
  <div id="content-wrapper">
    <b-tabs content-class="mt-3">
      <b-tab
        title="Thông tin người dùng"
        :active="activeTab === `#${NGUOI_DUNG_TAB.THONG_TIN_NGUOI_DUNG}`"
        @click="changeCurrentTab(NGUOI_DUNG_TAB.THONG_TIN_NGUOI_DUNG)"
      >
        <div class="box box-form">
          <FormNguoiDung
            ref="cap-nhat-vai-tro"
            :form="chiTietNguoiDung"
            :readonly="true"
            :danh-sach-can-bo="danhSachCanBoLayVaoNguoiDung"
          />
        </div>
      </b-tab>
      <b-tab
        title="Nhóm người dùng/ vai trò"
        :active="activeTab === `#${NGUOI_DUNG_TAB.VAI_TRO}`"
        @click="changeCurrentTab(NGUOI_DUNG_TAB.VAI_TRO)"
      >
        <div class="box box-form">
          <div class="row mb-3">
            <div class="col-md-6 col-xs-12">
              <b-form-group
                label="Đơn vị - chức vụ"
                label-for="don-vi"
                label-class="font-weight-bold font-size-16"
              >
                <v-select
                  :options="(chiTietNguoiDung || {}).lstDonViChucVu"
                  :reduce="(app) => app.id"
                  label="donViChucVu"
                  v-model="
                    internalChiTietNguoiDung.userCanBoDepartmentDefaultId
                  "
                  placeholder="Đơn vị - chức vụ"
                  :clearable="false"
                  ><span slot="no-options">
                    Không tìm thấy dữ liệu
                  </span></v-select
                >
              </b-form-group>
            </div>
            <div class="col-md-6 col-xs-12">
              <b-form-group
                label="Ứng dụng"
                label-for="ung-dung"
                label-class="font-weight-bold font-size-16"
              >
                <v-select
                  :options="danhSachAppNoiBo"
                  id="id"
                  label="name"
                  :reduce="(app) => app.id"
                  v-model="internalAppId"
                  :readonly="true"
                  placeholder="Chọn ứng dụng"
                >
                  <span slot="no-options">
                    Không tìm thấy dữ liệu
                  </span></v-select
                >
              </b-form-group>
            </div>
          </div>
          <hr />
          <div
            class="form-title mb-0 text-center text-danger"
            v-if="!chiTietNguoiDung.userCanBoDepartmentDefaultId"
          >
            <b-icon icon="exclamation-circle-fill" variant="danger"></b-icon>
            Không thể chọn vai trò/ nhóm người dùng do người dùng chưa được gán
            cán bộ, hoặc cán bộ chưa thuộc đơn vị nào
          </div>
          <div v-else>
            <DanhSachVaiTroTheoNguoiDung
              :readonly="true"
              ref="danhSachVaiTroTheoNguoiDung"
              :key="`xem-role-thuoc-nguoi-dung-${
                chiTietNguoiDung &&
                chiTietNguoiDung.user &&
                chiTietNguoiDung.user.id
              }`"
              :chiTietNguoiDung="{
                ...internalChiTietNguoiDung,
                userCanBoDepartmentId:
                  internalChiTietNguoiDung.userCanBoDepartmentDefaultId,
              }"
              :appId="internalAppId"
            />
            <div class="mt-3 mb-3">
              <hr />
            </div>
            <DanhSachGroupTheoNguoiDung
              class="mt-3"
              :readonly="true"
              ref="danhSachGroupTheoNguoiDung"
              :key="`xem-group-thuoc-nguoi-dung-${
                chiTietNguoiDung &&
                chiTietNguoiDung.user &&
                chiTietNguoiDung.user.id
              }`"
              :chiTietNguoiDung="{
                ...internalChiTietNguoiDung,
                userCanBoDepartmentId:
                  internalChiTietNguoiDung.userCanBoDepartmentDefaultId,
              }"
              :appId="internalAppId"
            />
          </div>
        </div>
      </b-tab>
      <b-tab
        title="Phân quyền"
        :active="activeTab === `#${NGUOI_DUNG_TAB.QUYEN}`"
        @click="changeCurrentTab(NGUOI_DUNG_TAB.QUYEN)"
      >
        <div class="box box-form">
          <div class="row mb-3">
            <div class="col-md-6 col-xs-12">
              <b-form-group
                label="Đơn vị - chức vụ"
                label-for="don-vi"
                label-class="font-weight-bold font-size-16"
              >
                <v-select
                  :options="(chiTietNguoiDung || {}).lstDonViChucVu"
                  :reduce="(app) => app.id"
                  label="donViChucVu"
                  v-model="
                    internalChiTietNguoiDung.userCanBoDepartmentDefaultId
                  "
                  placeholder="Đơn vị - chức vụ"
                  :clearable="false"
                  ><span slot="no-options">
                    Không tìm thấy dữ liệu
                  </span></v-select
                >
              </b-form-group>
            </div>
            <div class="col-md-6 col-xs-12">
              <b-form-group
                label="Ứng dụng"
                label-for="ung-dung"
                label-class="font-weight-bold font-size-16"
              >
                <v-select
                  :options="danhSachAppNoiBo"
                  id="id"
                  label="name"
                  :reduce="(app) => app.id"
                  v-model="internalAppId"
                  :readonly="true"
                  placeholder="Chọn ứng dụng"
                >
                  <span slot="no-options">
                    Không tìm thấy dữ liệu
                  </span></v-select
                >
              </b-form-group>
            </div>
          </div>
          <hr />
          <DanhSachQuyenTheoNguoiDung
            :readonly="true"
            ref="danhSachQuyenTrongNguoiDung"
            :key="`danh-sach-quyen-${
              chiTietNguoiDung &&
              chiTietNguoiDung.data &&
              chiTietNguoiDung.data.user &&
              chiTietNguoiDung.data.user.id
            }`"
            :appId="internalAppId"
            :chiTietNguoiDung="{
              ...internalChiTietNguoiDung,
              userCanBoDepartmentId:
                internalChiTietNguoiDung.userCanBoDepartmentDefaultId,
            }"
          />
        </div>
      </b-tab>
    </b-tabs>
    <div class="d-flex justify-content-end">
      <base-button
        button="Cập nhật"
        @click="capNhat()"
        v-if="hasPermissionUser(PERMISSION_NAME.NGUOI_DUNG.SUA)"
      ></base-button>
<!--      <b-button-->
<!--        class="btn btn-blue"-->
<!--        @click="resetQR()"-->
<!--        v-if="hasPermissionUser(PERMISSION_NAME.NGUOI_DUNG.RESET_2FA) && chiTietNguoiDung.isUsingSecretKey2FA"-->
<!--      >-->
<!--        <font-awesome-icon-->
<!--          icon="redo"-->
<!--          v-b-popover.hover.top="'Reset mã xác thực'"-->
<!--          class="cursor-pointer color-red"-->
<!--        />-->
<!--        Reset mã xác thực-->
<!--      </b-button>-->
      <base-button button="Đóng" @click="boQua()"></base-button>
    </div>
  </div>
</template>

<script>
import {
  ROUTE_NAME,
  BO_QUA_BUTTON_LABEL,
  NGUOI_DUNG_TAB,
  PERMISSION_NAME,
} from "@/constants/constants";
import { hasPermissionUser } from "@/utils/permissionUtils";
import FormNguoiDung from "@/components/pages/quan-tri-he-thong/nguoi-dung/FormNguoiDung";
import DanhSachVaiTroTheoNguoiDung from "@/components/pages/quan-tri-he-thong/vai-tro/DanhSachVaiTroTheoNguoiDung";
import DanhSachGroupTheoNguoiDung from "@/components/pages/quan-tri-he-thong/group/DanhSachGroupTheoNguoiDung";
import DanhSachQuyenTheoNguoiDung from "@/components/pages/quan-tri-he-thong/quyen/DanhSachQuyenTheoNguoiDung";
import { mapGetters } from "vuex";
export default {
  name: "XemNguoiDung",
  data() {
    return {
      PERMISSION_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      internalChiTietVaiTro: {},
      activeTab: NGUOI_DUNG_TAB.THONG_TIN_NGUOI_DUNG,
      NGUOI_DUNG_TAB: NGUOI_DUNG_TAB,
      internalChiTietNguoiDung: {},
      internalAppId: null,
    };
  },
  components: {
    FormNguoiDung,
    DanhSachVaiTroTheoNguoiDung,
    DanhSachQuyenTheoNguoiDung,
    DanhSachGroupTheoNguoiDung,
  },
  computed: {
    ...mapGetters({
      chiTietNguoiDung: "user/chiTietNguoiDung",
      danhSachApp: "app/tatCaApp",
      danhSachCanBo: "user/danhSachCanBoLayVaoNguoiDung",
    }),
    danhSachCanBoLayVaoNguoiDung() {
      if (!this.danhSachCanBo) {
        return [];
      }
      let danhSach = [];
      danhSach = (this.danhSachCanBo.items || []).map((item) => {
        return {
          id: item.id,
          name: item.userName,
          ...item,
        };
      });
      return danhSach;
    },
    danhSachAppNoiBo() {
      return this.danhSachApp.filter((x) =>
        (this.internalChiTietNguoiDung.applicationIds || []).includes(x.id)
      );
    },
  },
  created() {
    this.activeTab = location.hash;
    this.$store.dispatch("user/layChiTietNguoiDung", {
      id: this.$router.currentRoute.params.id,
    });
    this.$store
      .dispatch("user/layDanhSachCanBoVaoNguoiDung", {
        UserId: this.$router.currentRoute.params.id,
        PageIndex: 1,
        PageSize: 50,
      })
      .then(() => {});
  },
  watch: {
    chiTietNguoiDung: {
      handler() {
        this.internalChiTietNguoiDung = Object.assign(
          {},
          this.internalChiTietNguoiDung,
          this.chiTietNguoiDung
        );
        // if (
        //   this.internalChiTietNguoiDung.applicationIds &&
        //   this.internalChiTietNguoiDung.applicationIds.length
        // ) {
        //   this.internalAppId = this.internalChiTietNguoiDung.applicationIds[0];
        // }
      },
    },

    internalAppId: {
      handler() {},
      deep: true,
    },
  },
  methods: {
    hasPermissionUser,
    capNhat() {
      this.$router.push({
        path: `${ROUTE_NAME.QUAN_TRI_HE_THONG.NAME}${ROUTE_NAME.QUAN_TRI_HE_THONG.NGUOI_DUNG}/${this.$router.currentRoute.params.id}`,
      });
    },
    resetQR() {
      this.$store
          .dispatch("user/resetQRUser", {
            userId: this.$router.currentRoute.params.id,
          })
          .then((res) => {
            if (res.data.succeeded) {
              this.$toasted.clear();
              this.$toasted.global.showSuccessMessage({
                message: "Reset mã xác thực thành công",
              });
            }
          })
          .catch(() => {
            this.$toasted.clear();
            this.$toasted.global.showSuccessMessage({
              message: "Thao tác thất bại",
            });
          });
    },
    changeCurrentTab(currentTab) {
      this.$router
        .push({
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.XEM_CHI_TIET_NGUOI_DUNG,
          hash: `#${currentTab}`,
        })
        .catch(() => {});
    },
    boQua() {
      this.$router.push({
        name: ROUTE_NAME.QUAN_TRI_HE_THONG.NGUOI_DUNG,
      });
    },
  },
};
</script>


